/*
 * Pasek nagrod w koszyku - silnik.
 *
 * Konfiguracja: snippet cart-rewards-config.liquid renderuje #crw-config-data na KAZDEJ stronie,
 * wiec silnik dziala takze na /cart, gdzie szuflada koszyka nie istnieje.
 *
 * Linie-nagrody rozpoznajemy po wlasciwosci _auto_gift, nie po variant_id. Dzieki temu klient
 * moze normalnie kupic ten sam produkt (w dowolnej ilosci), a my ruszamy tylko wlasne linie.
 *
 * Liczba krokow jest dowolna (1-5) i wynika z konfiguracji - markup krokow budowany jest tutaj.
 */
(function () {
  if (window.__CartRewardsV3) return;
  window.__CartRewardsV3 = true;

  var CIRCLE = 112;
  var STROKE = 3.5;
  var REF_SWEEP = 165;
  var GIFT_PROP = '_auto_gift';
  var GIFT_HDR = { 'X-CRW-GIFT': '1' };
  var RING_TRANSITION =
    'stroke-dasharray 500ms cubic-bezier(0.23, 1, 0.32, 1), transform 500ms cubic-bezier(0.23, 1, 0.32, 1), opacity 250ms';

  /* ---------------------------------------------------------------- utils */

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, a);
      }, ms);
    };
  }

  function clamp(n, lo, hi) {
    return Math.max(lo, Math.min(n, hi));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function productWord(n) {
    if (n === 1) return 'produkt';
    var t = n % 10;
    var h = n % 100;
    if (t >= 2 && t <= 4 && (h < 12 || h > 14)) return 'produkty';
    return 'produktów';
  }

  function sweepFor(progress) {
    if (progress <= 0) return 0;
    if (progress >= 1) return 360;
    var ref = 303 / 400;
    if (progress <= ref) return (progress / ref) * REF_SWEEP;
    return REF_SWEEP + ((progress - ref) / (1 - ref)) * (360 - REF_SWEEP);
  }

  function setRing(circle, sweep, opts, instant) {
    if (!circle) return;
    var r = (CIRCLE - STROKE) / 2;
    var circ = 2 * Math.PI * r;
    var val = Number(sweep);
    if (!isFinite(val)) val = 0; // rowne progi / zly config nie moga wyzerowac pierscienia
    var clamped = clamp(val, 0, 360);
    var len = (circ * clamped) / 360;
    var rotation = opts && opts.endDeg !== undefined ? opts.endDeg - clamped : (opts && opts.startDeg) || 0;
    if (instant) circle.style.transition = 'none';
    circle.style.strokeDasharray = len + ' ' + circ;
    circle.style.opacity = clamped > 0 ? '1' : '0';
    circle.style.transform = 'rotate(' + rotation + 'deg)';
    if (instant) {
      void circle.offsetWidth;
      circle.style.transition = RING_TRANSITION;
    }
  }

  function burstHtml() {
    var out = [];
    for (var k = 0; k < 10; k++) out.push('<i style="--a:' + k * 36 + 'deg;--d:' + (((k % 3) * 60) + 40) + 'ms"></i>');
    return out.join('');
  }

  /* --------------------------------------------------------------- config */

  var CFG = null;

  // Zabezpieczenie magazynowe: krok z nagroda znika z paska, gdy zapas zjedzie ponizej progu
  // z panelu. Nie obiecujemy wtedy nagrody, ktorej moze nie byc na stanie w chwili zamowienia -
  // ostatnie sztuki zostaja buforem na koszyki, ktore sa juz w drodze do kasy.
  // Liczymy tylko warianty ze sledzeniem stanow (patrz komentarz w cart-rewards-config.liquid).
  function stockBlocked(s) {
    if (s.type !== 'gift') return false;
    if (!s.stockTracked || s.stockMin <= 0) return false;
    return s.stock < s.stockMin;
  }

  function visibleSteps(all) {
    return all.filter(function (s) {
      return !stockBlocked(s);
    });
  }

  function stepsSignature(steps) {
    return steps
      .map(function (s) {
        return s.slot;
      })
      .join(',');
  }

  function readConfig() {
    var el = document.getElementById('crw-config-data');
    if (!el) return null;
    var raw;
    try {
      raw = JSON.parse(el.textContent.trim());
    } catch (e) {
      console.warn('[CartRewards] zly JSON konfiguracji', e);
      return null;
    }
    if (!raw || raw.enabled === false) return null;

    var steps = (raw.steps || [])
      .map(function (s, idx) {
        return {
          idx: idx,
          slot: Number(s.slot) || idx + 1,
          type: String(s.type || 'info'),
          amount: Math.max(0, Number(s.amount) || 0),
          variantId: Number(s.variantId) || 0,
          productTitle: String(s.productTitle || ''),
          productPrice: Math.max(0, Number(s.productPrice) || 0),
          stockMin: Math.max(0, Number(s.stockMin) || 0),
          stock: Number(s.stock) || 0,
          stockTracked: s.stockTracked === true,
          rewardName: String(s.rewardName || ''),
          image: String(s.image || ''),
          title: String(s.title || ''),
          sub: String(s.sub || ''),
          badge: String(s.badge || ''),
          badgeWide: String(s.badgeWide || ''),
          tipOff: String(s.tipOff || ''),
          tipOn: String(s.tipOn || ''),
        };
      })
      .filter(function (s) {
        // Krok typu "gift" bez wybranego produktu obiecywalby nagrode, ktorej nie da sie dodac.
        if (s.type === 'gift' && !s.variantId) {
          console.warn('[CartRewards] krok ' + s.slot + ' ma typ "produkt", ale nie wybrano produktu - pomijam');
          return false;
        }
        return true;
      });

    if (!steps.length) return null;

    // allSteps = takze kroki ukryte przez zapas. Silnik musi o nich wiedziec, zeby wyczyscic
    // nagrode z koszykow, w ktorych zdazyla wyladowac, zanim zapas spadl ponizej progu.
    raw.allSteps = steps;
    raw.steps = visibleSteps(steps);
    raw.currency = raw.currency || 'zł';
    raw.text = raw.text || {};
    return raw;
  }

  // Swiezy zapas z odswiezonej szuflady koszyka (snippet cart-rewards-widget).
  // Zwraca true, gdy zmienil sie zestaw widocznych krokow - wtedy pasek trzeba przebudowac.
  function refreshStockFromDom() {
    if (!CFG) return false;
    var el = document.querySelector('[data-crw-stock]');
    if (!el) return false;
    var map;
    try {
      map = JSON.parse(el.textContent.trim());
    } catch (e) {
      return false;
    }
    if (!map) return false;

    CFG.allSteps.forEach(function (s) {
      var qty = Number(map[s.slot]);
      if (isFinite(qty)) s.stock = qty;
    });

    var prevSig = stepsSignature(CFG.steps);
    CFG.steps = visibleSteps(CFG.allSteps);
    if (stepsSignature(CFG.steps) === prevSig) return false;

    instances.forEach(function (root) {
      if (root.dataset.crwInited !== '1') return;
      buildSteps(root);
      renderRoot(root, state.total, state.count, true);
      showRoot(root);
    });
    return true;
  }

  function fmtMoney(n) {
    return Math.max(0, Math.round(Number(n) || 0)) + ' ' + (CFG ? CFG.currency : 'zł');
  }

  // {value} (wartosc produktu-nagrody): podloga zamiast zaokraglenia (39.99 -> 39,
  // "o wartosci 40 zl" przy cenie 39.99 brzmi jak klamstwo) i BEZ spacji przed
  // waluta - "39zl" nie lamie sie do nowej linii w banerze.
  function fmtValue(cents) {
    return Math.floor(Math.max(0, Number(cents) || 0) / 100) + (CFG ? CFG.currency : 'zł');
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : m;
    });
  }

  // Naglowek banera: jak fill(), ale wynik to bezpieczny HTML, w ktorym {reward}
  // dostaje <em> - zloty akcent z .cr-banner__text h2 em. Wszystko escapowane.
  function fillBannerHtml(tpl, vars) {
    return esc(String(tpl || '')).replace(/\{(\w+)\}/g, function (m, key) {
      if (!Object.prototype.hasOwnProperty.call(vars, key)) return m;
      var v = esc(String(vars[key]));
      return key === 'reward' ? '<em>' + v + '</em>' : v;
    });
  }

  /* ------------------------------------------------------------ stan koszyka */

  var state = { total: 0, count: 0 };
  var lastGiftVariants = new Set(); // warianty obecne w koszyku jako AUTO-nagroda
  var ourRemovals = new Set(); // usuniecia wykonane przez nas (nie licz ich jako rezygnacja klienta)
  var dismissed = loadDismissed(); // klient recznie usunal nagrode - nie wracamy z nia
  var unavailable = new Set(); // nie udalo sie dodac (wyprzedane / 422 / offline)

  function loadDismissed() {
    try {
      var raw = sessionStorage.getItem('crwDismissed');
      var arr = raw ? JSON.parse(raw) : [];
      return new Set(Array.isArray(arr) ? arr.map(Number) : []);
    } catch (e) {
      return new Set();
    }
  }

  function saveDismissed() {
    try {
      sessionStorage.setItem('crwDismissed', JSON.stringify([].concat(Array.from(dismissed))));
    } catch (e) {
      /* prywatny tryb przegladarki - trudno */
    }
  }

  function isGiftLine(li) {
    var p = li && li.properties;
    return !!(p && Object.prototype.hasOwnProperty.call(p, GIFT_PROP));
  }

  // Suma kwalifikujaca: wszystko POZA naszymi auto-nagrodami.
  function qualifying(cart) {
    if (!cart || !Array.isArray(cart.items)) return { total: 0, count: 0, gifts: new Map() };
    var cents = 0;
    var count = 0;
    var gifts = new Map();
    for (var i = 0; i < cart.items.length; i++) {
      var li = cart.items[i];
      if (isGiftLine(li)) {
        var vid = Number(li.variant_id);
        var prev = gifts.get(vid);
        // Ten sam wariant moze wystapic w kilku liniach - zbieramy wszystkie klucze.
        if (prev) {
          prev.qty += Number(li.quantity) || 0;
          prev.keys.push(li.key);
        } else {
          gifts.set(vid, { qty: Number(li.quantity) || 0, keys: [li.key] });
        }
        continue;
      }
      var line =
        typeof li.final_line_price === 'number' ? li.final_line_price : (Number(li.price) || 0) * (Number(li.quantity) || 0);
      cents += line;
      count += Number(li.quantity) || 0;
    }
    var orderDiscount = (cart.cart_level_discount_applications || []).reduce(function (sum, discount) {
      return discount.target_type === 'shipping_line' ? sum : sum + (Number(discount.total_allocated_amount) || 0);
    }, 0);
    cents = typeof cart.__crwDiscountedTotal === 'number' ? cart.__crwDiscountedTotal : cents - orderDiscount;
    return { total: Math.max(0, cents) / 100, count: count, gifts: gifts };
  }

  /* ------------------------------------------------------- budowa markupu */

  function stepIconHtml(step) {
    if (step.image) {
      return '<img class="cr-art-img" src="' + esc(step.image) + '" alt="" loading="lazy" width="96" height="96">';
    }
    if (step.type === 'shipping') {
      return (
        '<svg class="cr-step__truck" viewBox="0 0 38 28" width="19" height="14" fill="none" stroke="currentColor" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" stroke-width="2">' +
        '<rect x="2.6" y="5.4" width="18.4" height="13.6" rx="1.8"></rect>' +
        '<path d="M21 9.8h5.9a2 2 0 0 1 1.55.73l3.3 4.05c.3.36.45.8.45 1.27v1.35a1.8 1.8 0 0 1-1.8 1.8h-1.6"></path>' +
        '<circle cx="10" cy="21.8" r="3"></circle><circle cx="27.2" cy="21.8" r="3"></circle></svg>'
      );
    }
    if (step.type === 'start') {
      return (
        '<svg class="cr-step__check" viewBox="0 0 30 30" width="15" height="15" fill="none" stroke="currentColor" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" stroke-width="3.2">' +
        '<path d="M7.6 15.8l5.1 5.1 9.7-11.6"></path></svg>'
      );
    }
    return '<svg viewBox="0 0 120 120" class="cr-art" aria-hidden="true"><circle cx="60" cy="60" r="40" fill="#1a1a1e"/></svg>';
  }

  function buildSteps(root) {
    var ol = root.querySelector('[data-cr-steps]');
    if (!ol) return;
    var steps = CFG.steps;
    var html = '';

    for (var i = 0; i < steps.length; i++) {
      var s = steps[i];
      var isLast = i === steps.length - 1;
      var photo = s.image ? ' cr-step--photo' : '';
      var discMod = s.image ? ' cr-step__disc--photo' : s.type === 'start' ? ' cr-step__disc--dark cr-step__disc--zero' : '';

      html +=
        '<li class="cr-step' + photo + '" data-cr-step="' + i + '" data-cr-type="' + esc(s.type) + '">' +
        '<div class="cr-step__disc-area">' +
        '<svg class="cr-step__ring" width="100%" height="100%" viewBox="0 0 112 112" aria-hidden="true">' +
        '<circle cx="56" cy="56" r="54.25" fill="none" stroke="var(--cr-gold)" stroke-width="3.5" ' +
        'stroke-linecap="round" stroke-dasharray="0 340.86" ' +
        'style="opacity:0;transform-origin:50% 50%;transition:' + RING_TRANSITION + ';"></circle>' +
        '</svg>' +
        '<div class="cr-step__disc' + discMod + '">' + stepIconHtml(s) + '</div>' +
        (s.badge
          ? '<span class="cr-step__price" data-cr-badge>' +
            (s.badgeWide
              ? '<span class="cr-step__price-wide" data-cr-badge-wide></span>' +
                '<span class="cr-step__price-narrow" data-cr-badge-narrow></span>'
              : '') +
            '</span>'
          : '') +
        '<span data-cr-done hidden class="cr-step__done" aria-hidden="true">' +
        '<svg viewBox="0 0 30 30" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" ' +
        'stroke-width="3.2"><path d="M7.6 15.8l5.1 5.1 9.7-11.6"></path></svg></span>' +
        '<span data-cr-burst></span>' +
        '<button type="button" class="cr-step__hit" aria-expanded="false" data-cr-hit="' + i + '"></button>' +
        '</div>' +
        (isLast
          ? ''
          : '<div class="cr-step__connector cr-step__connector--dashed" aria-hidden="true">' +
            '<svg class="cr-step__connector-svg"><line x1="0" y1="50%" x2="100%" y2="50%"></line></svg>' +
            '<span class="cr-step__connector-label" data-cr-conn-label></span></div>') +
        '<div class="cr-step__text">' +
        '<h3 class="cr-step__title" data-cr-title></h3>' +
        '<p class="cr-step__sub" data-cr-sub></p>' +
        '</div>' +
        '</li>';
    }
    ol.innerHTML = html;
  }

  /* --------------------------------------------------------------- render */

  var instances = new Set();
  var preserved = null;
  var seenUnlocked = new Set(); // do animacji "wlasnie odblokowane"
  var firstPaintDone = false;

  function stepVars(s, total, count) {
    // ceil, nie round: przy brakujacych 31.03 zl komunikat "za 31 zl" klamie -
    // klient dodaje rowno 31 zl i dalej nie ma progu
    var missing = Math.ceil(Math.max(0, s.amount - total));
    var vars = {
      amount: fmtMoney(missing),
      threshold: fmtMoney(s.amount),
      product: s.productTitle || '',
      value: fmtValue(s.productPrice),
      count: count,
      count_word: productWord(count),
      total: fmtMoney(total),
    };
    // "Nazwa nagrody w banerze" z panelu (moze uzywac {value}/{product}/{threshold});
    // pusta = pelna nazwa produktu jak dotad.
    vars.reward = s.rewardName ? fill(s.rewardName, vars) : s.productTitle || s.sub || s.title || '';
    return vars;
  }

  function renderRoot(root, total, count, instant) {
    if (!root || root.dataset.crwInited !== '1') return;
    var steps = CFG.steps;
    var ol = root.querySelector('[data-cr-steps]');
    var banner = root.querySelector('[data-cr-banner]');
    var els = root.querySelectorAll('[data-cr-step]');
    if (!els.length) return;

    var unlockedFlags = [];
    var firstLocked = -1;

    for (var i = 0; i < steps.length; i++) {
      var s = steps[i];
      var ok = s.amount <= 0 ? count > 0 : total >= s.amount && count > 0;
      if (s.type === 'gift' && unavailable.has(s.variantId)) ok = false; // nie klam, ze klient ma nagrode
      unlockedFlags.push(ok);
      if (!ok && firstLocked === -1) firstLocked = i;
    }

    var allDone = unlockedFlags.every(Boolean);
    if (ol) ol.classList.toggle('cr-steps--complete', allDone);

    // Krok, ktory promujemy (boost/glow/baner): pierwszy zablokowany REALNY prog kwotowy.
    // Przy pustym koszyku firstLocked wskazuje krok startowy (0 zl) - podswietlalby sie
    // "licznik produktow", a baner mowilby o dostawie. Celujemy oba w to samo.
    var focusIdx = firstLocked;
    if (focusIdx >= 0 && steps[focusIdx].amount <= 0) {
      for (var f = focusIdx + 1; f < steps.length; f++) {
        if (!unlockedFlags[f] && steps[f].amount > 0) {
          focusIdx = f;
          break;
        }
      }
    }

    var tiers = [];

    for (var j = 0; j < steps.length; j++) {
      var st = steps[j];
      var el = els[j];
      if (!el) continue;
      var unlocked = unlockedFlags[j];
      var vars = stepVars(st, total, count);

      // pierscien: postep od progu poprzedniego kroku do progu tego kroku
      var prevAmount = j > 0 ? steps[j - 1].amount : 0;
      var span = st.amount - prevAmount;
      var progress;
      if (st.amount <= 0) progress = count > 0 ? 1 : 0;
      else if (span <= 0) progress = total >= st.amount ? 1 : 0; // rowne progi - bez dzielenia przez zero
      else progress = clamp((total - prevAmount) / span, 0, 1);

      var ringInstant = !firstPaintDone || instant;
      setRing(el.querySelector('circle'), st.amount <= 0 ? (count > 0 ? 360 : 0) : sweepFor(progress), { endDeg: 0 }, ringInstant);

      var justUnlocked = unlocked && firstPaintDone && !seenUnlocked.has(st.slot);
      if (unlocked) seenUnlocked.add(st.slot);
      else seenUnlocked.delete(st.slot);

      var done = el.querySelector('[data-cr-done]');
      if (done) {
        done.hidden = !unlocked;
        // is-pop zdejmujemy dopiero po animacji - kolejny render (np. po auto-dodaniu
        // gratisu ~200-600ms pozniej) ucinal 300ms animacje w polowie
        if (justUnlocked) {
          done.classList.add('is-pop');
          done.addEventListener(
            'animationend',
            function () {
              done.classList.remove('is-pop');
            },
            { once: true }
          );
        } else if (!unlocked) {
          done.classList.remove('is-pop');
        }
      }

      el.classList.toggle('cr-step--boost', j === focusIdx || (allDone && j === steps.length - 1));
      el.classList.toggle('cr-step--glow', j === focusIdx || (allDone && j === steps.length - 1));
      el.classList.toggle('cr-step--stacked', st.type === 'start' && !allDone && unlockedFlags[0] && firstLocked > 1);
      el.classList.toggle('cr-step--docked', st.type === 'shipping' && unlocked && !allDone);

      var disc = el.querySelector('.cr-step__disc');
      if (disc && st.type === 'start') disc.classList.toggle('cr-step__disc--zero', count === 0);

      // konektor do nastepnego kroku
      var conn = el.querySelector('.cr-step__connector');
      if (conn) {
        var nextStep = steps[j + 1];
        conn.classList.toggle('cr-step__connector--gold', unlocked);
        conn.classList.toggle('cr-step__connector--dashed', !unlocked);
        conn.classList.toggle('cr-step__connector--flow', unlocked && j + 1 === focusIdx);
        var lbl = conn.querySelector('[data-cr-conn-label]');
        if (lbl) {
          var lblTxt = nextStep && nextStep.amount > 0 ? fmtMoney(nextStep.amount) : '';
          if (lbl.textContent !== lblTxt) lbl.textContent = lblTxt;
        }
      }

      // odznaka
      var badge = el.querySelector('[data-cr-badge]');
      if (badge) {
        var unavail = st.type === 'gift' && unavailable.has(st.variantId);
        var badgeTxt = unavail ? CFG.text.unavailable || '' : fill(st.badge, vars);
        var wideEl = badge.querySelector('[data-cr-badge-wide]');
        if (wideEl) {
          // Dwie wersje odznaki: CSS pokazuje pelna tam, gdzie sie miesci,
          // a skrocona na waskich ekranach. Komunikat o niedostepnosci - obie takie same.
          var narrowEl = badge.querySelector('[data-cr-badge-narrow]');
          var wideTxt = unavail ? badgeTxt : fill(st.badgeWide, vars);
          if (wideEl.textContent !== wideTxt) wideEl.textContent = wideTxt;
          if (narrowEl && narrowEl.textContent !== badgeTxt) narrowEl.textContent = badgeTxt;
        } else if (badge.textContent !== badgeTxt) {
          badge.textContent = badgeTxt;
        }
      }

      // teksty - zapis tylko przy realnej zmianie: kazdy zbedny zapis textContent
      // to mutacja DOM, ktora budzi MutationObservery innych skryptow koszyka
      var titleEl = el.querySelector('[data-cr-title]');
      var subEl = el.querySelector('[data-cr-sub]');
      var titleTxt = fill(st.title, vars);
      var subTxt = fill(st.sub, vars);
      if (titleEl && titleEl.textContent !== titleTxt) titleEl.textContent = titleTxt;
      if (subEl && subEl.textContent !== subTxt) subEl.textContent = subTxt;

      var hit = el.querySelector('[data-cr-hit]');
      if (hit) {
        var hitLbl = 'Szczegóły nagrody: ' + fill(st.title || st.sub || '', vars);
        if (hit.getAttribute('aria-label') !== hitLbl) hit.setAttribute('aria-label', hitLbl);
      }

      // burst przy swiezym odblokowaniu
      var burstHost = el.querySelector('[data-cr-burst]');
      if (burstHost) {
        if (justUnlocked) {
          burstHost.innerHTML = '<span class="cr-burst" aria-hidden="true">' + burstHtml() + '</span>';
          (function (host, node) {
            setTimeout(function () {
              if (host) host.innerHTML = '';
              node.classList.remove('cr-step--celebrate');
            }, 1000); // ostatnie iskry: 800ms animacji + 160ms delayu = 960ms
          })(burstHost, el);
          el.classList.add('cr-step--celebrate');
        } else if (!unlocked) {
          burstHost.innerHTML = '';
        }
      }

      tiers.push({
        title: fill(st.title || st.sub || '', vars),
        statusText: unlocked ? '✓ Odblokowane' : st.amount > 0 ? 'od ' + fmtMoney(st.amount) : '',
        body: unlocked ? fill(st.tipOn, vars) : fill(st.tipOff, vars),
      });
    }

    root.__crwTiers = tiers;

    // baner
    if (banner) {
      var target = focusIdx >= 0 ? steps[focusIdx] : null;
      var head;
      var headHtml;
      var sub;
      if (target) {
        var tv = stepVars(target, total, count);
        head = fill(CFG.text.bannerLocked, tv);
        headHtml = fillBannerHtml(CFG.text.bannerLocked, tv);
        sub = fill(CFG.text.bannerLockedSub, tv);
      } else {
        var lv = stepVars(steps[steps.length - 1], total, count);
        head = fill(CFG.text.bannerDone, lv);
        headHtml = fillBannerHtml(CFG.text.bannerDone, lv);
        sub = fill(CFG.text.bannerDoneSub, lv);
      }
      var h2 = banner.querySelector('h2');
      var p = banner.querySelector('p');
      // porownujemy po czystym tekscie (em nie zmienia textContent), wstawiamy HTML
      if (h2 && h2.textContent !== head) h2.innerHTML = headHtml;
      if (sub) {
        if (!p) {
          p = document.createElement('p');
          banner.appendChild(p);
        }
        if (p.textContent !== sub) p.textContent = sub;
      } else if (p) {
        p.remove();
      }
    }

    firstPaintDone = true;
  }

  function renderAll(total, count, instant) {
    state = { total: total, count: count };
    window.CartRewardsState = { cartTotal: total, itemCount: count };
    instances.forEach(function (root) {
      if (!root.isConnected && root !== preserved) {
        instances.delete(root);
        return;
      }
      try {
        renderRoot(root, total, count, instant);
      } catch (e) {
        console.warn('[CartRewards] render', e);
      }
    });
  }

  /* ---------------------------------------------------------------- dymki */

  function wireTiers(root) {
    var overlay = root.querySelector('.cr-tier-overlay');
    var pop = root.querySelector('.cr-tier-pop');
    if (!overlay || !pop) return;
    var open = null;

    function close() {
      open = null;
      overlay.hidden = true;
      pop.hidden = true;
      root.querySelectorAll('[data-cr-hit]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    root.addEventListener('click', function (e) {
      var hit = e.target.closest && e.target.closest('[data-cr-hit]');
      if (!hit || !root.contains(hit)) return;
      e.preventDefault();
      var i = Number(hit.dataset.crHit);
      var data = (root.__crwTiers || [])[i];
      if (!data) return;
      if (open === i) {
        close();
        return;
      }
      var area = hit.parentElement;
      var a = area.getBoundingClientRect();
      var pr = root.getBoundingClientRect();
      var half = Math.min(118, pr.width / 2);
      var x = clamp(a.left + a.width / 2 - pr.left, half, Math.max(pr.width - half, half));
      var below = a.top - pr.top < 90;
      open = i;
      pop.style.left = x + 'px';
      pop.style.top = (below ? a.bottom - pr.top + 10 : a.top - pr.top - 10) + 'px';
      pop.classList.toggle('cr-tier-pop--below', below);
      pop.querySelector('h4').textContent = data.title;
      pop.querySelector('.cr-tier-pop__detail').textContent = data.statusText;
      pop.querySelector('p').textContent = data.body;
      pop.hidden = false;
      overlay.hidden = false;
      root.querySelectorAll('[data-cr-hit]').forEach(function (b, idx) {
        b.setAttribute('aria-expanded', idx === i ? 'true' : 'false');
      });
    });

    overlay.addEventListener('click', close);
    root.__crwCloseTier = close;
  }

  /* ---------------------------------------------------------------- silnik */

  var busyTimer = null;

  function setBusy(on) {
    clearTimeout(busyTimer);
    document.querySelectorAll('[data-crw]').forEach(function (root) {
      root.classList.toggle('crw--busy', !!on);
      var hint = root.querySelector('[data-cr-busy]');
      if (!hint) return;
      hint.classList.toggle('is-on', !!on);
      if (on) hint.removeAttribute('hidden');
      else hint.setAttribute('hidden', '');
    });
  }

  function giftPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, GIFT_HDR),
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) {
        var err = new Error(url + ' ' + res.status);
        err.status = res.status;
        throw err;
      }
      return res.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' }).then(
      function (r) {
        if (!r.ok) throw new Error('Nie udalo sie odczytac koszyka');
        return r.json();
      }
    );
  }

  var cartRevision = 0;
  var pendingCartMutations = new Set();

  function nativeLines(cart) {
    return cart.items.map(function (item) {
      return [item.key, item.quantity, item.original_line_price, item.final_line_price];
    }).sort(function (a, b) { return String(a[0]).localeCompare(String(b[0])); });
  }

  function nativeQualifyingTotal(cart) {
    var hasOrderDiscount = (cart.cart_level_discount_applications || []).some(function (discount) {
      return discount.target_type !== 'shipping_line' && Number(discount.total_allocated_amount) > 0;
    });
    if (!hasOrderDiscount || !cart.items.some(isGiftLine)) return Promise.resolve(null);
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart?view=rewards-total', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Nie udalo sie przeliczyc nagrod');
        return response.json();
      }).then(function (result) {
        var lines = Array.isArray(result.lines) ? result.lines.slice().sort(function (a, b) {
          return String(a[0]).localeCompare(String(b[0]));
        }) : [];
        if (result.currency !== cart.currency || result.totalPrice !== cart.total_price ||
            JSON.stringify(lines) !== JSON.stringify(nativeLines(cart))) {
          var error = new Error('Koszyk zmienil sie podczas odczytu rabatow');
          error.staleCart = true;
          throw error;
        }
        if (!Number.isFinite(result.totalCents) || result.totalCents < 0) throw new Error('Nieprawidlowe rabaty koszyka');
        return result.totalCents;
      });
  }

  function fetchQualifiedCart() {
    if (pendingCartMutations.size) {
      return Promise.all(Array.from(pendingCartMutations).map(function (pending) {
        return pending.catch(function () {});
      })).then(fetchQualifiedCart);
    }
    var revision = cartRevision;
    return fetchCart().then(function (cart) {
      var discounts = window.CartDiscounts;
      if (!discounts) {
        var savedCodes;
        try { savedCodes = JSON.parse(localStorage.getItem('icedstuff_discounts') || '[]'); } catch (e) { savedCodes = []; }
        if (Array.isArray(savedCodes) && savedCodes.length) throw new Error('Przeliczanie rabatu jest niedostepne');
        return nativeQualifyingTotal(cart).then(function (total) {
          if (total !== null) cart.__crwDiscountedTotal = total;
          return cart;
        });
      }
      var signature = discounts.signature(cart);
      return discounts.qualifyingTotal(cart).then(function (total) {
        return total === null ? nativeQualifyingTotal(cart) : total;
      }).then(function (total) {
        return (total === null ? Promise.resolve(cart) : fetchCart()).then(function (latest) {
          if (revision !== cartRevision || signature !== discounts.signature(latest)) {
            var error = new Error('Koszyk zmienil sie podczas przeliczania rabatu');
            error.staleCart = true;
            throw error;
          }
          if (total !== null) {
            if (!Number.isFinite(total) || total < 0) throw new Error('Nieprawidlowa wartosc koszyka po rabacie');
            latest.__crwDiscountedTotal = Math.round(total);
          }
          return latest;
        });
      });
    });
  }

  function refreshCartPage() {
    var page = document.querySelector('[data-crw-cart-page]');
    if (!page) return Promise.resolve();
    var revision = cartRevision;
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(page.dataset.crwCartPage), {
      cache: 'no-store', credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Nie udalo sie odswiezyc strony koszyka');
      return response.text();
    }).then(function (html) {
      if (revision !== cartRevision) return;
      var updated = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-crw-cart-page]');
      if (!updated) throw new Error('Nieprawidlowa odpowiedz strony koszyka');
      var note = page.querySelector('[name="note"]');
      var nextNote = updated.querySelector('[name="note"]');
      if (note && nextNote) nextNote.value = note.value;
      page.replaceWith(updated);
    });
  }

  function giftSteps() {
    return CFG.allSteps.filter(function (s) {
      return s.type === 'gift' && s.variantId;
    });
  }

  // Wykryj rezygnacje klienta: nagroda byla w koszyku, zniknela, a to nie my ja usunelismy.
  function trackDismissals(gifts) {
    var now = new Set(Array.from(gifts.keys()));
    lastGiftVariants.forEach(function (vid) {
      if (!now.has(vid)) {
        if (ourRemovals.has(vid)) ourRemovals.delete(vid);
        else if (CFG.respectRemove) {
          dismissed.add(vid);
          saveDismissed();
        }
      }
    });
    lastGiftVariants = now;
  }

  function paint(cart) {
    refreshStockFromDom(); // zapas sprawdzamy przy kazdym odczycie koszyka, takze przed dodaniem nagrody
    var q = qualifying(cart);
    trackDismissals(q.gifts);

    // Pamiec animacji wejscia gratisow (layout/theme.liquid, sessionStorage) musi byc
    // przycinana do linii realnie obecnych w koszyku - robil to martwy GiftAuto, wiec
    // gratis animowal sie raz na sesje, a kazdy kolejny "po prostu sie pojawial".
    if (window.__giftAnim && typeof window.__giftAnim.prune === 'function') {
      var giftAnimKeys = [];
      q.gifts.forEach(function (g) {
        g.keys.forEach(function (k) { giftAnimKeys.push(k); });
      });
      window.__giftAnim.prune(giftAnimKeys);
    }

    // Zejscie ponizej progu kasuje rezygnacje i blokade niedostepnosci -
    // ponowne przekroczenie progu ma znow zaproponowac nagrode.
    giftSteps().forEach(function (s) {
      if (q.total < s.amount) {
        dismissed.delete(s.variantId);
        unavailable.delete(s.variantId);
        saveDismissed();
      }
    });

    renderAll(q.total, q.count);
    return q;
  }

  var syncing = false;
  var syncQueued = false;
  var syncPromise = null;
  var syncError = null;

  function syncGifts() {
    if (!CFG || !CFG.autoAdd) return Promise.resolve(false);
    if (syncing) {
      syncQueued = true;
      return syncPromise;
    }
    syncing = true;
    syncError = null;

    syncPromise = fetchQualifiedCart()
      .then(function (cart) {
        var q = paint(cart);
        var gifts = giftSteps();
        if (!gifts.length) return false;

        var toRemove = [];
        var toAdd = [];
        var toTrim = [];

        gifts.forEach(function (s) {
          var present = q.gifts.get(s.variantId);
          // Krok ukryty przez zapas: nie dodajemy nagrody i kasujemy ja z koszyka. Zostawiona
          // wywrocilaby kase - przy polityce "przestan sprzedawac" Shopify zablokuje zamowienie.
          var want = !stockBlocked(s) && q.total >= s.amount && q.count > 0;

          if (!want && present) {
            present.keys.forEach(function (k) {
              toRemove.push({ key: k, vid: s.variantId });
            });
          } else if (want && !present) {
            if (!dismissed.has(s.variantId) && !unavailable.has(s.variantId)) toAdd.push(s);
          } else if (want && present) {
            // duplikaty tego samego wariantu (kilka linii) lub ilosc > 1
            if (present.keys.length > 1) {
              present.keys.slice(1).forEach(function (k) {
                toRemove.push({ key: k, vid: s.variantId });
              });
            }
            if (present.qty > 1) toTrim.push({ key: present.keys[0], vid: s.variantId });
          }
        });

        if (!toRemove.length && !toAdd.length && !toTrim.length) return false;
        setBusy(true);

        // Zanim usuniemy linie gratisow na serwerze, wyprowadz ich wiersze z DOM
        // animacja (klasa .gift-removing z mini-carta). Bez tego wiersz znikal
        // dopiero przy pelnej podmianie szuflady - twardym cieciem, bez animacji.
        // Rownolegle z requestami; jesli inline zdazyl je juz zaanimowac - no-op.
        var animDone = Promise.resolve();
        if (toRemove.length) {
          var rowsOut = [];
          toRemove.forEach(function (r) {
            var esc = window.CSS && CSS.escape ? CSS.escape(r.key) : r.key;
            var row = document.querySelector('.is-free-gift[data-line-key="' + esc + '"]');
            if (row && !row.classList.contains('gift-removing')) {
              row.classList.add('gift-removing');
              rowsOut.push(row);
            }
          });
          if (rowsOut.length) {
            animDone = new Promise(function (res) {
              setTimeout(function () {
                rowsOut.forEach(function (row) {
                  if (row.parentNode) row.parentNode.removeChild(row);
                });
                res();
              }, 520);
            });
          }
        }

        var chain = Promise.resolve();
        toRemove.forEach(function (r) {
          chain = chain.then(function () {
            ourRemovals.add(r.vid);
            return giftPost('/cart/change.js', { id: r.key, quantity: 0 });
          });
        });
        toTrim.forEach(function (r) {
          chain = chain.then(function () {
            return giftPost('/cart/change.js', { id: r.key, quantity: 1 });
          });
        });
        function giftItem(s) {
          var props = {};
          props[GIFT_PROP] = String(s.slot);
          return { id: s.variantId, quantity: 1, properties: props };
        }

        // Nagroda niedostepna (wyprzedana / 422 / offline) - nie probuj w kolko
        // i nie udawaj, ze klient ja ma.
        function giftFailed(s, e) {
          console.warn('[CartRewards] nie udalo sie dodac nagrody (krok ' + s.slot + ')', e);
          unavailable.add(s.variantId);
        }

        if (toAdd.length) {
          chain = chain.then(function () {
            // WSZYSTKIE nalezne nagrody jednym zadaniem. Wczesniej szly osobnymi,
            // po kolei - przez ~0,7 s w koszyku byla tylko pierwsza z nich i klient,
            // ktory od razu szedl do kasy, wychodzil z niepelnym kompletem nagrod.
            if (toAdd.length === 1) {
              return giftPost('/cart/add.js', { items: [giftItem(toAdd[0])] }).catch(function (e) {
                giftFailed(toAdd[0], e);
              });
            }
            return giftPost('/cart/add.js', { items: toAdd.map(giftItem) }).catch(function () {
              // /cart/add.js jest atomowe: gdy JEDNA nagroda jest niedostepna, pada cale
              // zadanie. Wtedy dokladamy pojedynczo, zeby dostepne i tak trafily do koszyka.
              var fallback = Promise.resolve();
              toAdd.forEach(function (s) {
                fallback = fallback.then(function () {
                  return giftPost('/cart/add.js', { items: [giftItem(s)] }).catch(function (e) {
                    giftFailed(s, e);
                  });
                });
              });
              return fallback;
            });
          });
        }

        // czekamy takze na animacje wyjscia - dispatch cart:refresh (i pelna
        // podmiana szuflady) ma przyjsc PO niej, nie w jej trakcie
        return Promise.all([chain, animDone]).then(function () {
          return true;
        });
      })
      .then(function (changed) {
        if (changed) {
          return fetchQualifiedCart().then(function (cart) {
            paint(cart);
            return refreshCartPage().then(function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
              return true;
            });
          });
        }
        return false;
      })
      .catch(function (e) {
        syncError = e;
        if (e.staleCart) syncQueued = true;
        console.warn('[CartRewards] sync', e);
        return false;
      })
      .then(function (changed) {
        syncing = false;
        setBusy(false);
        if (syncQueued) {
          syncQueued = false;
          scheduleSync();
        }
        return changed;
      });
    return syncPromise;
  }

  var scheduleSync = debounce(function () {
    void syncGifts();
  }, 120);

  var refreshSeq = 0;

  function refreshFromServer() {
    var seq = ++refreshSeq;
    return fetchQualifiedCart()
      .then(function (cart) {
        // Starsza odpowiedz /cart.js po nowszej (szybkie klikanie ilosci) cofala
        // pierscienie o jeden stan - malujemy tylko najswiezsza.
        if (seq !== refreshSeq) return;
        paint(cart);
        scheduleSync();
      })
      .catch(function (e) {
        if (e.staleCart) refreshDebounced();
        console.warn('[CartRewards] refresh', e);
      });
  }

  var refreshDebounced = debounce(refreshFromServer, 180);

  /* ----------------------------------------------------------------- hooki */

  function isOurs(args) {
    var init = args[1];
    var req = args[0];
    var headers = (init && init.headers) || (req && typeof req === 'object' && req.headers);
    if (!headers) return false;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) return headers.get('X-CRW-GIFT') === '1';
    if (Array.isArray(headers)) {
      return headers.some(function (h) {
        return String(h[0]).toLowerCase() === 'x-crw-gift' && h[1] === '1';
      });
    }
    return headers['X-CRW-GIFT'] === '1' || headers['x-crw-gift'] === '1';
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function hookFetch() {
    if (window.__CartRewardsFetchHookedV3) return;
    window.__CartRewardsFetchHookedV3 = true;
    var orig = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var mutation = CART_MUTATION.test(u);
      var ours = mutation && isOurs(args);
      if (mutation && !ours) cartRevision++;
      var request = orig.apply(this, args);
      if (!mutation || ours) return request;
      var tracked = request.finally(function () {
        cartRevision++;
        pendingCartMutations.delete(tracked);
        refreshDebounced();
      });
      pendingCartMutations.add(tracked);
      return tracked;
    };
  }

  // Motyw i czesc aplikacji (jQuery) zmieniaja koszyk przez XHR - bez tego progi sie nie odswiezaja.
  function hookXHR() {
    if (window.__CartRewardsXHRHookedV3 || typeof XMLHttpRequest === 'undefined') return;
    window.__CartRewardsXHRHookedV3 = true;
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__crwCart = CART_MUTATION.test(String(url || ''));
      } catch (e) {
        this.__crwCart = false;
      }
      return open.apply(this, arguments);
    };
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__crwCart) {
        cartRevision++;
        var finish;
        var pending = new Promise(function (resolve) { finish = resolve; });
        pendingCartMutations.add(pending);
        this.addEventListener('loadend', function () {
          cartRevision++;
          pendingCartMutations.delete(pending);
          finish();
          refreshDebounced();
        }, { once: true });
      }
      return send.apply(this, arguments);
    };
  }

  function hookEvents() {
    if (window.__CartRewardsEventsHookedV3) return;
    window.__CartRewardsEventsHookedV3 = true;

    document.addEventListener('cart:refresh', stash, true);
    document.addEventListener('cart:updated', function () {
      stash();
      refreshDebounced();
    });

    ['added_to_cart', 'ajaxProduct:added', 'cart:add', 'cart:item:added', 'cart:update', 'line-item:updated',
      'discount:applied', 'discount:removed', 'discount:updated'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        refreshDebounced();
      });
    });

    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action*="/cart"]')) refreshDebounced();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-crw]').forEach(function (r) {
        if (r.__crwCloseTier) r.__crwCloseTier();
      });
    });

    // druga karta przegladarki zmienila koszyk
    window.addEventListener('pageshow', function () {
      refreshDebounced();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshDebounced();
    });
  }

  /* ------------------------------------------------------------- start-up */

  // Gdy zapas zdjal WSZYSTKIE kroki, pasek nie ma czego pokazac - chowamy go razem z banerem.
  function showRoot(root) {
    root.style.display = CFG.steps.length ? '' : 'none';
  }

  function initRoot(root) {
    if (!root || root.dataset.crwInited === '1') return null;
    buildSteps(root);
    wireTiers(root);
    root.dataset.crwInited = '1';
    root.classList.add('crw--ready');
    renderRoot(root, state.total, state.count, true);
    showRoot(root);
    return root;
  }

  function initAll() {
    document.querySelectorAll('[data-crw]').forEach(function (root) {
      var inst = initRoot(root);
      if (inst) instances.add(inst);
    });
  }

  function stash() {
    var el = document.querySelector('[data-crw][data-crw-inited="1"]');
    if (el) preserved = el;
  }

  function adopt() {
    var fresh = document.querySelector('[data-crw]');
    if (!fresh) return;
    refreshStockFromDom(); // razem z odswiezona szuflada przyszedl swiezy zapas nagrod
    if (preserved && preserved !== fresh && !fresh.dataset.crwInited) {
      fresh.replaceWith(preserved);
      instances.add(preserved);
      renderRoot(preserved, state.total, state.count, true);
      return;
    }
    initAll();
    var live = document.querySelector('[data-crw][data-crw-inited="1"]');
    if (live) preserved = live;
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('[data-crw]')) || (n.querySelector && n.querySelector('[data-crw]'))) {
          adopt();
          return;
        }
      }
    }
  });

  function boot() {
    CFG = readConfig();
    if (!CFG) return; // widget wylaczony w panelu lub brak krokow - nie ruszamy koszyka

    if (CFG.gold) document.documentElement.style.setProperty('--cr-gold', CFG.gold);

    state = { total: Number(CFG.initialTotal) || 0, count: Number(CFG.initialCount) || 0 };
    window.CartRewardsState = { cartTotal: state.total, itemCount: state.count };

    initAll();
    hookFetch();
    hookXHR();
    hookEvents();
    mo.observe(document.body, { childList: true, subtree: true });
    refreshFromServer();
  }

  window.CartRewards = {
    refresh: refreshFromServer,
    sync: function () {
      return syncGifts();
    },
    settle: function () {
      return Promise.resolve(syncing ? syncPromise : null).then(function () {
        return syncGifts();
      }).then(function () {
        if (syncError) throw syncError;
      });
    },
    setBusy: setBusy,
    get config() {
      return CFG;
    },
    get state() {
      return state;
    },
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
